import axios from "axios";
import {
    config,
    useKeycloak,
    sessionAccessToken,
    sessionActiveTime,
    sessionRefreshToken,
    sessionIdToken,
    sessionUser,
    sessionUsername,
    sessionUserPerms,
} from "../config";
import {
    getUserByUsername,
    getUserInfoViaToken,
    getUserPermissionsByUsername,
    entraLoginUrl
} from "../services/userService";
import {BASE_URL, HIEBUS_CONFIG} from "./authConfig";
import {logActivity} from "../services/utilService";

function rand() {
    return (Date.now() + "" + Math.random()).replace(".", "");
}

function redirect404() {
    window.location = BASE_URL + "unauthorized";
}

export default class AuthService {
    signinRedirect = () => {
        window.location = entraLoginUrl()
    };

    isAuthenticated = () => {
        const token = sessionStorage.getItem(sessionAccessToken);
        return !!token;
    };

    logoutClient = () => {
        if ((process.env.REACT_APP_CLIENT_AUTH).includes('level2'))
            window.location = HIEBUS_CONFIG.logout_uri + '?id_token_hint=' + sessionStorage.getItem(sessionIdToken)
        else
            window.location = BASE_URL
        sessionStorage.clear();
        localStorage.clear();
    };

    navigateToScreen = () => {
        window.location.replace(BASE_URL);
    };

    signinRedirectCallback = async () => {
        let result = new URLSearchParams(window.location.search);

        if (!result.has("error"))
        {
            const preferred_username = result.get("username")

            const jwtToken = result.get("token")

            sessionStorage.clear();
            sessionStorage.setItem(sessionAccessToken, jwtToken)
            sessionStorage.setItem(sessionActiveTime, Date.now())
            sessionStorage.setItem(sessionUsername, preferred_username);

            localStorage.removeItem(HIEBUS_CONFIG.client_id + "_state");
            
            let {data: user} = await getUserByUsername(preferred_username);
            if (user.length === 0) {
                sessionStorage.removeItem(sessionUsername);
                sessionStorage.removeItem(sessionActiveTime);
                sessionStorage.removeItem(sessionAccessToken);
                redirect404();
            }
            sessionStorage.setItem(sessionUser, JSON.stringify(user[0]));

            const {data: userPermissions} = await getUserPermissionsByUsername(preferred_username);
            sessionStorage.setItem(sessionUserPerms, JSON.stringify(userPermissions));
            await logActivity("/login", "LOGIN_SUCCESS");
            userPermissions && (window.location = BASE_URL);
        } else {
            redirect404();
        }
    };
}
